import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Settings, Inbox, BarChart3 } from 'lucide-react';

const TABS = [
  { path: '/marketing/website-chat', label: 'Setup', icon: Settings },
  { path: '/marketing/website-chat/inbox', label: 'Inbox', icon: Inbox },
  { path: '/marketing/website-chat/analytics', label: 'Analytics', icon: BarChart3 },
];

export function WebsiteChatNav() {
  const navigate = useNavigate();
  const { pathname } = useLocation();

  return (
    <div className="flex items-center gap-1 border-b px-4 bg-background" data-testid="webchat-nav">
      {TABS.map(({ path, label, icon: Icon }) => {
        const active = pathname === path;
        return (
          <button
            key={path}
            onClick={() => navigate(path)}
            data-testid={`webchat-nav-${label.toLowerCase()}`}
            className={`flex items-center gap-1.5 px-3 py-2.5 text-sm font-medium border-b-2 transition-colors -mb-px ${
              active
                ? 'border-blue-600 text-blue-600'
                : 'border-transparent text-muted-foreground hover:text-foreground hover:border-muted-foreground/30'
            }`}
          >
            <Icon className="w-4 h-4" />
            {label}
          </button>
        );
      })}
    </div>
  );
}
